import React, {useState, useContext} from 'react';
import {Layout, Card, Stack, Button, Checkbox} from '@shopify/polaris';
import {AppProvider} from '@thinkwell/react.polaris';
import Container from './Container'
import Content from './Content'
import EditCourseTree from './EditCourseTree'
import {CourseTreeContext} from '../contexts/CourseTree'

export default function CourseTree(props) {
  const [courseTree, updateCourseTree] = useContext(CourseTreeContext)
  const [editing, setEditing] = useState(false)
  const [contentOnly, setContentOnly] = useState(false)

  const {child_nodes, course} = courseTree

  return (
    <div className="course-tree">
      <Layout>
        <Layout.Section primary>
          {
            editing ?
              <EditCourseTree
              onEditing={(_editing) => { if (_editing != editing) { setEditing(_editing) } }}
              />
            : null
          }
          { !editing ?
            <Card>
              <Card.Header title={course.name}>
                <Stack alignment="center">
                  <Checkbox checked={contentOnly} onChange={() => { setContentOnly(!contentOnly) }} label="Content Only"></Checkbox>
                  <Button plain onClick={() => { setEditing(true) }}>Edit</Button>
                </Stack>
              </Card.Header>
              <Card.Section>
              {
                contentOnly ?
                  courseTree.contents().map((content_node) => {
                    const parent = courseTree.findNode(content_node.parent_node_id)
                    return <Content item={content_node} name={`${parent.number} ${parent.name} - ${content_node.name}`} key={content_node.id} />
                  }) :
                  child_nodes.map((child_node) => {
                    if (child_node.type == 'container') {
                      return <Container item={child_node} key={child_node.id}/>
                    }
                    else if (child_node.type == 'content') {
                      return <Content item={child_node} key={child_node.id} />
                    }
                  })
              }
              </Card.Section>
            </Card> : null
          }
        </Layout.Section>
      </Layout>
    </div>)
}
